import {
  VOUCHERS_PENDING,
  VOUCHERS_FAILED,
  VOUCHERS_DOWNLOADED,
  VOUCHERS_RESET,
  VOUCHER_SENDING,
  VOUCHER_DOWNLOADED,
  VOUCHER_REMOVED,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
};

export default function (state = INITIAL_STATE, action) {
  let vouchers = [];
  let voucherIndex = -1;
  switch (action.type) {
    case VOUCHERS_RESET:
      return INITIAL_STATE;
    case VOUCHERS_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case VOUCHERS_DOWNLOADED: {
      if (state.content) {
        vouchers = state.content.slice();
      }
      const newVouchers = action.payload;
      const mergedVouchers = vouchers.concat(newVouchers.filter((voucher) => vouchers.indexOf(voucher) < 0));
      return {
        error: null,
        pending: false,
        sending: false,
        content: mergedVouchers,
      };
    }
    case VOUCHER_SENDING:
      return {
        ...state,
        sending: true,
      };
    case VOUCHER_DOWNLOADED:
      if (state.content) {
        vouchers = state.content.slice();
        voucherIndex = vouchers.findIndex((voucher) => voucher.id === action.payload.id);
      }
      if (voucherIndex === -1) {
        vouchers.push(action.payload);
      } else {
        vouchers[voucherIndex] = action.payload;
      }
      return {
        error: null,
        pending: false,
        sending: false,
        content: vouchers,
      };
    case VOUCHERS_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    case VOUCHER_REMOVED: {
      if (state.content) {
        vouchers = state.content.slice();
        voucherIndex = vouchers.findIndex((voucher) => voucher.id === action.payload.id);
        if (voucherIndex !== -1) {
          vouchers.splice(voucherIndex, 1);
        }
      }
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: vouchers,
      };
    }
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/vouchers/reducers.js